
export function getGetCare(props) {
    const { hasMyChart, epicEHRDown, bundle, isActiveFeature_OnlineAppointmentScheduling, isActiveFeature_AmbulatoryVideoVisit
        , isActiveFeature_SDCVideoVisit, isActiveFeature_EVisit, sameDayVideoVisitScheduleEnabled, hasAuthorizedFeatureSameDayVideo
        , isProxyUser, enableInHomeFeature, currentPharmacyUser, isMyChartInActive   } = props;
    const pathname = typeof window !== "undefined" ? window.location.pathname.toLowerCase() : "";
    const isPharmacy = bundle === "pharmacy" || pathname.indexOf('/pharmacy') === 0;
    const isMyBSWHealth = bundle === "mybswhealth" && !isPharmacy;
    const notPharmacyProxy = isMyBSWHealth || isPharmacy && !currentPharmacyUser;
    const enabledVirtualDashboard = serverData && serverData.enableVirtualDashboardUpdates ? serverData.enableVirtualDashboardUpdates : false;
    const careOptionType = enabledVirtualDashboard ? "Get Care" : serverData && serverData.careOptions ? serverData.careOptions : "Convenient Care Options";
    const enableCustomDirectScheduling = serverData && serverData.enableCustomDirectScheduling;
    const showVideoOnDemand = sameDayVideoVisitScheduleEnabled && isActiveFeature_OnlineAppointmentScheduling && ((isActiveFeature_SDCVideoVisit) || (hasAuthorizedFeatureSameDayVideo));
    const isMyChartProxyUser = isProxyUser;
    return {
        icon: 'icon-find-care',
        show: notPharmacyProxy,
        navHead: {
            label: 'Get Care',
            url: null,
            altUrls: ['/getcare', '/schedule']
        },
        navItems: [
            {
                label: 'Schedule Now',
                show: notPharmacyProxy && hasMyChart,
                url: '/schedulenow',
                altUrls: [
                    '/schedulingfor',
                    '/evisitnow',
                    '/evisittravel',
                    '/evisit',
                    '/aatravel',
                    '/videovisitoptions',
                    '/videovisitscheduledfor',
                    '/schedulevideovisit',
                    '/videovisitscheduledfor',
                    '/videoondemand',
                    '/schedulevisit',
                    '/scheduling',
                    '/vaccineeligibility'
                ],
                subMenuItems: null,
                disabled: epicEHRDown || isMyChartInActive,
            },
            {
                label: 'Find Care',
                show: notPharmacyProxy,
                url: '/findcare',
                altUrls: ['/inperson'],
                subMenuItems: null
            },
            {
                label: 'Favorite Doctors',
                show: notPharmacyProxy && !isMyChartProxyUser,
                url: '/favorites',
                subMenuItems: null
            },
            {
                label: 'In-Home Services',
                show: enableInHomeFeature,
                url: '/inhomevaccine',
                altUrls: ['/inhomeschedule'],
                subMenuItems: null
            }
        ]
    }
}